import {
  FETCH_JUSTIFICATIONS_PA_LIST_REQUEST,
  FETCH_JUSTIFICATIONS_PA_LIST_SUCCESS,
  FETCH_JUSTIFICATIONS_PA_LIST_ERROR,
  UPDATE_JUSTIFICATION_PA_REQUEST,
  UPDATE_JUSTIFICATION_PA_SUCCESS,
  UPDATE_JUSTIFICATION_PA_ERROR,
} from 'actionTypes'

const DEFAULT_STATE = {
  list: {
    records: [],
    error: null,
    isFetching: false,
  },
  edit: {
    record: {},
    error: null,
    isUpdating: false,
  },
}

const list = (state = DEFAULT_STATE, action) => {
  const data = action.payload

  switch (action.type) {
    case FETCH_JUSTIFICATIONS_PA_LIST_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: true,
        },
      }

    case FETCH_JUSTIFICATIONS_PA_LIST_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          error: null,
          records: data,
        },
      }

    case FETCH_JUSTIFICATIONS_PA_LIST_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: false,
          records: [],
          error: data,
        },
      }

    case UPDATE_JUSTIFICATION_PA_REQUEST:
      return {
        ...state,
        edit: {
          ...state.edit,
          isUpdating: true,
        },
      }

    case UPDATE_JUSTIFICATION_PA_SUCCESS:
      return {
        ...state,
        edit: {
          ...state.edit,
          isUpdating: false,
          error: null,
          record: data,
        },
      }

    case UPDATE_JUSTIFICATION_PA_ERROR:
      return {
        ...state,
        edit: {
          ...state.edit,
          isUpdating: false,
          error: data,
          record: {},
        },
      }

    default:
      return state
  }
}

export default list
